import { useMutation } from '@tanstack/react-query';

import { authenticationService } from 'services';

export const useLogout = () => {
  const { isSuccess, mutateAsync: logout } = useMutation({
    mutationFn: () => authenticationService.logout(),
  });

  return { isSuccess, logout };
};
